import { DirectCampaignModel } from '../../data-layer/direct/types';
import { pluralize } from '../../utils/pluralize';

export const toDirectCampaignUI = (companies: DirectCampaignModel[]) =>
    companies.map((campaign) => {
        const { feedSettings, ...rest } = campaign;

        return {
            ...rest,
            content: getContentText(feedSettings),
            feedSettings: {
                posts: feedSettings.banned_post_ids.map((id) => String(id)),
                useAllPosts: feedSettings.use_all_posts,
                freshnessDays: feedSettings.freshness_days,
            },
        };
    });

const getContentText = (feedSettings: {
    use_all_posts: boolean;
    freshness_days: number;
    banned_post_ids?: string[];
}) => {
    if (feedSettings.banned_post_ids?.length) {
        return 'Выбранные посты';
    }

    if (feedSettings.use_all_posts) {
        return 'Все посты';
    }

    if (feedSettings.freshness_days) {
        const days = feedSettings.freshness_days;

        return `Посты за ${days} ${pluralize(days, 'день', 'дня', 'дней')}`;
    }

    return '';
};
